import styled, { css, keyframes } from 'styled-components';
import { getStyle as get } from '@ids/ddms-styled/comps/toast/intuit/light';
import { transitionState } from '@ids/transition';
import LinkActionButton from '@ids-beta/link-action-button';

const fadeEnter = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const fadeExit = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

const downEnter = keyframes`
  from {
    transform: translateY(-90px);
    }
  to {
    transform: none;
  }
`;

const upExit = keyframes`
  from {
    transform: none;
  }
  to {
    transform: translateY(-90px);
  }
`;

const transitionEnter = css`
  animation: ${fadeEnter} 250ms cubic-bezier(0.35, 0, 0.5, 1) backwards,
    ${downEnter} 750ms cubic-bezier(0.15, 1.3, 0.3, 1) backwards;
`;

const transitionExit = css`
  animation: ${fadeExit} 250ms cubic-bezier(0.35, 0, 0.5, 1) 500ms forwards,
    ${upExit} 750ms cubic-bezier(0.7, -0.1, 0.6, 0.1) forwards;
`;

const transitionStatusMap = {
  [transitionState.ENTERING]: transitionEnter,
  [transitionState.ENTERED]: transitionEnter,
  [transitionState.EXITING]: transitionExit
};

const toastFontFamily =
  'Avenir Next forINTUIT,Avenir,Helvetica,Arial,sans-serif';

export const Wrapper = styled.div`
  position: absolute;
  top: 16px;
  left: 50%;
  outline: none;
  margin-left: -230px;
  font-family: ${toastFontFamily};
  @media only screen and (max-width: 969px) {
    @content;
  }
  ${props => transitionStatusMap[props.transitionState]}
`;

export const Message = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  width: 460px;
  padding: 16px;
  line-height: 0;
  outline: none;
  position: relative;
  background-color: ${get('background.color')};
  border-radius: ${get('background.radius')};
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  border: ${get('border.stroke')} solid ${get('border.color')};
`;

// TODO: replace font family with updated $toastFont
export const Text = styled.p`
  overflow: hidden;
  color: ${get('text.color')};
  text-align: left;
  flex-grow: 1;
  font: ${get('text.fontStyle')} ${get('text.fontWeight')}
    ${get('text.fontSize')} ${toastFontFamily}; /* stylelint-disable */
  line-height: ${get('text.lineHeight')};
  margin: 0;
`;

// TODO: changed from $green02 - no toast message Icon color in DD
// TODO: not in DDMS anymore ${get('icon.spacing')};
export const Icon = styled.span`
  flex: none;
  width: ${get('icon.width')};
  height: ${get('icon.height')};
  fill: #2ca01c;
  margin-right: 8px;
`;

export const CustomLinkActionButton = styled(LinkActionButton)`
  margin-left: 16px;
  max-width: 70px;
  background: 0;
  text-align: right;
`;
